import React from "react";
import "./Title.css";

const Title = props => 
    <div className="jumbotron">
        <h1>Baby Animals Clicky Game</h1>
        <h3>Click on an image below to earn points, but don't click on any more than once!</h3>
    </div>;

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title/Title.js